import { DateTime } from 'luxon';
import { useBudgetLocale } from '../budget/budget-store';
import { useGetUserApi } from '../user/api/use-get-user';
import { toLocaleString } from '../utils/format';
export function useTimeFormatter() {
    const locale = useBudgetLocale();
    const { data: user } = useGetUserApi();
    const userTimeZone = user?.timeZone || 'UTC';
    const formatter = new Intl.DateTimeFormat(toLocaleString(locale), {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZone: userTimeZone,
    });
    return (isoDate) => {
        if (!isoDate) {
            return '';
        }
        const dateTime = DateTime.fromISO(isoDate).setZone(userTimeZone);
        if (!dateTime.isValid) {
            console.error(`Invalid date string: ${isoDate}`);
            return '';
        }
        return formatter.format(dateTime.toJSDate());
    };
}
